import {useSelector} from "react-redux";
import {useState} from "react";
import './main.scss'

const Backdrop = () => {

    const [themeNumber, setThemeNumber] = useState(1)
    const {backdrop} = useSelector((state) =>{
        return {backdrop: state.core.backdrop}
    })

    const onBackDropClick = () => {
        var number = themeNumber
        number++;
        if(number > 6)
            number = 1
        setThemeNumber(number)
    }

    const backDropTheme = `theme${themeNumber}`
    const style = backdrop ? {} : {height: "0px"}

    return (
        <div
            className={`backdrop ${backDropTheme}`}
            style={style}
            onClick={onBackDropClick}
        >
        </div>
    )
}

export default Backdrop